import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setConfigLoading } from "redux/configurationReducer";
// import { config } from "assets/common/dynamicConfig";
// import { config } from 'assets/gift/dynamicConfig'
// import { config } from "assets/physical-Form-cr";
import Layout from "components/Layout";
import DynamicForm from "components/DynamicForm";
import { Row } from "react-bootstrap";
import { UAE_PASS_ROUTE } from "constants/routes";

import {
  fetchWorkflow,
  updateWorkflowInfo,
  updateApplicantStatusAndSubWorkflowStatus,
  getWorkflowInfo,
  getWorkflowData,
  createPrimaryWorkFlow,
  updateLastLoginInfo,
 createSubWorkFlow, 
 getFormComponents,
 updatePrimaryWorkflow

} from "api/formDisplay";
import { checkLinkForExpiryBasedOnID, getConfiguration } from "api/configuration";

import {
  changeActiveGroup,
  changeMaxActiveSection,
  changeActiveSection,
  setPrimaryUser,
  setApplicantUser,
  changeMaxActiveGroup,
  setworkflowUser,
} from "redux/userInfo";
import {
  clearSelectedData,
  clearValidateTriggered,
  setEvaluationRule,
  setFormGenerator,
  setFormGeneratorData,
  setIsToggled,
  setRestrictedView,
  setSelectedData,
} from "redux/formDisplay";
import {
  setShowDataPreview,
  clearSaveData,
  setRecursiveFormData,
  setShowRecursiveForm,
  clearShowData,
  setShowAddMore,
  clearRecursiveFormData,
  setIsEditRecursiveForm,
  setRecursiveActions,
  setAddSaveData,
  clearRecursiveFormDataKey,
  setIsSignerRecursion,
  cleardeleteRecursiveDocument,
  clearSignerParams
} from "redux/recursiveReducer";
import { encryptURLParams, encryptUrl } from "api/UrlEncryption";
import {
  setShowData,
  setFormFields,
  setArrayName,
} from "redux/recursiveReducer";
import { createUserWorkflowPayload } from "helper/createPayload";
import conditionalRendering, {
  incrementActiveStepOrder,
  setActiveStepOrder,
  setDynamicConfigId,
  setConfigurationId,
  setUserInitiatedRequired
} from "redux/conditionalRendering";
import Recursive from "components/Recursive";
import { setConsentConfig, setConsentId } from "redux/consentReducer";
import { setPrimaryWorkflowId } from "redux/conditionalRendering";
import { dynamicFormScroll, dynamicFormScrollBottom } from "utils";
import { Group, QuizModule, VerificationGroup } from "lib";
import Question from "components/Questions";
import FormButton from "components/FormButton";
import Consent from "components/Consent";
import { validate } from "components/DynamicForm/validate";
import {validateESign} from "components/ESign/validateESign"
import { uniqueWorkFlowId } from "helper/uniqueWorkFlowId";
import { createMasterDataPayload } from "helper/createPayload";

import {
  setBanner,
  setFormOccupancy,
  setNavOrientation,
  setSections,
  setStepperDisplay,
} from "redux/stepperReducer";
import { setUrlId } from "redux/urlEncryption"
import { getConsent } from "api/consent";
// import { IndirectEval } from "helper/indirectEval";
import { setConsentSections } from "redux/consentReducer";
// import { Logger } from "sass";
import FieldRecursion from "lib/FieldRecursion";
import { formGenerator } from "helper/formGenerator";
import { getRequestedDocByReqId } from "api/dashboardDetail";
import { clearRequestedDocs, setIsViewMode } from "redux/requestedDocReducer";
import LoadingSpinner from "lib/LoadingSpinner";
import FieldRecursive from "lib/FieldRecursion";
import { clearFieldRecursionData } from "redux/fieldRecursiveReducer";
import { setLoadingState } from "redux/staticData";
import { getCountriesCode } from "api/formDisplay";
import moment from "moment";
import { setconsentText, setdeclarationConsent } from "redux/consentReducer";
import { getAllSignerId,autoFillData } from "helper";
import { cleardeleteDocument,setdeleteDocument } from "redux/uploadDocumentReducer";
import { triggerButtonCallback } from "helper/triggerButtonCallback";
import { initiateUaePassAuth } from "api/uae-pass";
import Esign from "components/ESign";
import Emandate from "lib/Emandate";
import { getPaymentAndUserInfo, initiatePayment, sendEmailsBasedOnRoleOnAction, updatePaymentStatusInSubWorkflow } from "api/payment";
import PaymentTransactionPreview from "components/PaymentTransactionPreview";
import { setIsCreatingPayment } from "redux/paymentReducer";
import { encrypt } from "helper/encryptDecrypt";
import { getRolesInfo } from "api/user";

const FormDisplay = () => {

  let  finalPayload,is_verified;  
  const dispatch = useDispatch();
  const urlParams = useParams();
  const { redirectionConfigId } = useParams();
  const navigate = useNavigate();
  const activeGroup = useSelector((state) => state.userInfo.activeGroup);
  const activeSection = useSelector((state) => state.userInfo.activeSection);
  const maxActiveSection = useSelector(
    (state) => state.userInfo.maxActiveSection
  );
  const userInfo = useSelector((state) => state.userInfo);

  const applicantUser = useSelector((state) => state.userInfo?.applicantUser);
  const maxActiveGroup = useSelector((state) => state.userInfo.maxActiveGroup);
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const verificationResponses = useSelector((state) => state.uploadDocumentReducer);

  const formGeneratorFormFields = useSelector(
    (state) => state.formData?.formGenerator
  );
  const formGeneratorData = useSelector(
    (state) => state.formData?.formGeneratorData
  );
  const savedFormData = useSelector(
    (state) => state?.fieldRecursiveReducer?.saveData
  );
  const fieldRecursiveName = useSelector(
    (state) => state?.fieldRecursiveReducer?.fieldRecursiveName
  );
  const selectedQuestion = useSelector(
    (state) => state.formData?.selectedQuestion
  );
  const userId = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo?.profileInfo?.userId
  )
  const dataPreview = useSelector((state) => state.recursive?.showDataPreview);
  const saveData = useSelector((state) => state.recursive?.saveData);
  const formFields = useSelector((state) => state.recursive?.formFields);
  const configLoader = useSelector(
    (state) => state.configurationReducer?.loading
  );
  const workflowLoader = useSelector((state) => state.formData?.loading);
  const response = useSelector(
    (state) => state.uploadDocumentReducer?.response
  );
  const uploadedDocument = useSelector(
    (state) => state.uploadDocumentReducer?.uploadedDocument
  );
  const evaluationRule = useSelector((state) => state.formData?.evaluationRule)
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);
  const workflowUser = useSelector((state) => state.userInfo?.workflowUser);
  const countryData = useSelector((state) => state.staticData?.countryData);
  const userDetail = useSelector((state) => state.userInfo?.userDetail);
  const recursiveFormData = useSelector(
    (state) => state.recursive?.recursiveFormData
  );
  const loggedInUserInfo = useSelector((state) => state.loggedInUserInfo?.userAuthInfo);
  // let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  // const logged_in_user_organisation_id =
  //   loggedInUserInfo?.organisationInfo?._id;
  const formButtons = useSelector((state) => state.recursive.formButtons);
  const arrayName = useSelector((state) => state?.recursive?.arrayName);
  const showRecursiveForm = useSelector(
    (state) => state.recursive.showRecursiveForm
  );
  const payment_ids = useSelector((state) => state?.userInfo?.primaryUser?.payment_ids?.length);
  const config = useSelector(( state) => state.configurationReducer?.config);
  const dynamic_wf = config?.dynamic_wf;
  const user_initiated =  config?.user_initiated
  //comment

  const recursive = useSelector((state) => state.recursive);
  const questionData = useSelector((state) => state.formData?.questionData);
  const questionnaireId = useSelector(
    (state) => state.formData?.questionnaireId
  );
  const isEditRecursiveForm = useSelector(
    (state) => state.recursive.isEditRecursiveForm
  );
  const formData = useSelector((state) => state.formData);
  const stepperSections = useSelector(
    (state) => state?.stepperReducer?.sections
  );
  const receivedConsent = useSelector(
    (state) => state?.consentReducer?.consentConfig
  );
  const isSignerRecursion = useSelector(
    (state) => state.recursive?.isSignerRecursion
  );
  const requestedDocs = useSelector(
    (state) => state?.requestedDocReducer?.requestedDocs
  );
  const userInfoUpdatedSuccessfully = useSelector(
    (state) => state?.formData?.userInfoUpdatedSuccessfully
  );
  const email = useSelector((state) => state.otpReducer?.email);
  const otpReducer = useSelector((state) => state.otpReducer)
  const dynamicConfigId = useSelector(
    (state) => state.conditionalRendering?.dynamicConfigId
  );
  const documents = useSelector(
    (state) => state?.uploadDocumentReducer?.documents
  );
  const deleteDocument = useSelector((state)=> state?.uploadDocumentReducer?.deleteDocument)
  const deleteRecursiveDocument = useSelector((state)=> state.recursive?.deleteRecursiveDocument)
  const consentId = useSelector(
    (state) => state?.consentReducer?.consentConfig?._id
  );
  const userInitatedRequired = useSelector((state) => state.conditionalRendering?.userInitatedRequired)

  const consentText = useSelector(
    (state) => state?.consentReducer?.consentText
  );
  const consentType = useSelector(
    (state) => state?.consentReducer?.consentConfig?.service_name
  );
  const declarationConsent = useSelector(
    (state) => state?.consentReducer?.declarationConsent
  );
  const blockSection = useSelector(
    (state) => state?.userInfo?.activeSection
  );
  const blockGroup = useSelector(
    (state) => state?.userInfo?.activeGroup
  );
  const currentFormType = useSelector(
    (state) => state?.recursive?.currentFormType
  );
  const isEmailVerified = useSelector(
    (state) => state.otpReducer?.isEmailVerified
  );
  const isMobileVerified = useSelector(
    (state) => state.otpReducer?.isMobileVerified
  );
  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);
  const wfJourney = useSelector((state) => state?.configurationReducer?.config?.wf_journey)
  const organisation_id = config?.organisation_id;
  const configurationId = useSelector(
    (state) => state.conditionalRendering?.configurationId
  );
  const staticData = useSelector((state) => state.staticData);
  const status = useSelector((state) => state.staticData?.status);
  let activeStepOrder = useSelector(
    (state) => state.conditionalRendering?.activeStepOrder
  );
  let activeStepOfUser = useSelector(
    (state) => state.userInfo?.userDetail?.active_step
  );
  const isDuplicateFormInput = useSelector((state) => state.formData.isDuplicateFormInput);
  let stage = 0;
    const dynamicFormsSteps = config?.wf_journey?.filter(step => step.module_name === "Dynamic Forms");
    const activeStep = activeStepOfUser
    if (activeStep) {
        const activeIndex = dynamicFormsSteps?.findIndex(step => step.step == activeStep);
        if (activeIndex !== -1) {
            stage = activeIndex;
        }
    }
if(wfJourney){
  wfJourney.forEach(item => {
    if (item.type === "default" && item.module_name === "Dynamic Forms") {
        item.form_structure.sections
            .filter(section => section.type !== "banner") 
            .forEach(section => {
                section.form_groups.forEach(data => {
                    if (data.name === "otp_verification" && !eval(data.show)) {
                        is_verified = true;
                    }
            });
       });
    }
  });
}

  const [isRoutingToPaymentObject, setIsRoutingToPaymentObject] = useState({
    isRoutingToPayment: false,
    isGenerationOfPaymentIDInProgress: false,
    isRoutingInternalUserAsHeCannotPay: false,
  })
  const isPAymentIDCreationInProgress = useRef(false);

  const currentStep = useSelector((state) => state.stepperReducer?.sections[1]?.form_groups?.find(group =>(( group?.group_order === maxActiveSection)&&( group?.group_order === maxActiveGroup))))
  //from the url fetch the query params that is after ? in the url
  const search = window.location.search;
  const query = new URLSearchParams(search);
  const queryPath = query.get("physical_form");

  const requestedId = React.useMemo(() => {
    //optimization
    return query.get("requestedId");
  }, [search,query]);

  const updateCustomBtn = React.useMemo(() => {
    return query.get("updateCustomBtn");
  }, [search,query]);

  const isUserInitiated = React.useMemo(() => {
    //optimization
    return query.get("userInitiated");
  }, [search,query]);

  const read_mode = React.useMemo(() => {
    //optimization
    return query.get("read_mode");
  }, [search,query]);

  const trigger = React.useMemo(() => {
    //optimization
    return query.get("trigger");
  }, [search,query]);


  let formStructure = {},
    sections = {},
    fields,
    banner;
  const [formErr, setFormErr] = useState({});
  const [reqDocsObject, setReqDocsObject] = useState({});

  //Mobile responsiveness state
  const [isMobile, setIsMobile] = useState(false);
  const [isCreateWorkFlowLoading, setIsCreateWorkFlowLoading] = useState(false);
  const stateErrRef = useRef();
  const selectedDataRef = useRef();
  stateErrRef.current = { ...formErr };
  selectedDataRef.current = { ...selectedData };
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  
  const handleRedirect = async (link) => {
    const splitLink = link?.split("/");
    const subWfId = await encryptUrl(splitLink[3]);
    // const userId = await encryptUrl(splitLink[2]);
    navigate(`${link}${(loggedUserId && "?userInitiated=true") || "" }`);
  };
  let formComponents = ["eMandate"];

  const flattendData = {
    ...uploadedDocument,
    ...selectedData.primaryworkflow,
    ...selectedData.subworkFlowInfo,
    subworkFlowInfo: selectedData.subworkFlowInfo,
    ...selectedData
  };
  const handleUpdateButtons = [
    {
      label: "",
      action: "cancel",
    },
    {
      label: "Update",
      action: "updateRequestedChanges",
      disabled : "(recursive?.isEditRecursiveForm == true || recursive?.showRecursiveForm == true) ",
      className: "primary_button",
      content_trigger :{
        trigger :trigger,
        organisation_id:organisation_id
      }
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      let response1;
      if (decryptedId?.subWfId) {
        let response = await getWorkflowData(decryptedId.subWfId);
        if (response) {
          dispatch(getConfiguration(response?.configuration_id));
        }
        if (decryptedId.primaryWorkflowId) {
          response1 =
            decryptedId?.subWfId === decryptedId.primaryWorkflowId
              ? response
              : await getWorkflowData(decryptedId.primaryWorkflowId);
          if (response1) {
            dispatch(setPrimaryUser(response1));
            const sourceData = response1?.source_data;
            dispatch(setworkflowUser({ ...sourceData, subworkflows: "" }));
            sourceData.subworkflows.forEach((element) => {
              if (decryptedId.subWfId == element._id) {
                dispatch(
                  setworkflowUser({ ...sourceData, subworkflows: element })
                );
                if (element?.user_id != decryptedId?.userId) {
                  // When applicant edit co-applicant Form, then applicant will always land on first section instead of active section
                  dispatch(changeActiveGroup(1));
                  dispatch(changeActiveSection(1));
                  dispatch(setRestrictedView(true));
                } else {
                  dispatch(setRestrictedView(false));
                }
              }
            });
            if (isUserInitiated) {
              // When RM EDITS , WILL ALWAYS LAND ON FIRST SECTION INSTEAD OF ACTIVE SECTION
              dispatch(changeActiveGroup(1));
              dispatch(changeActiveSection(1));
            }
            if (countryData?.length == 0 && status == false) {
              dispatch(setLoadingState(true));
              dispatch(getCountriesCode());
            }
          }
        }
        let data = {
          primary_workflow_id: response1?._id || null,
          subworkflow: decryptedId?.subWfId,
          organisation_id: response?.organisation_id,
          LoginInfo: new Date(),
        };
        updateLastLoginInfo(data);

        // sdispatching getWorkflowInfo after fetchWorkflow is done
        dispatch(getWorkflowInfo(decryptedId.subWfId));
      }
    };
    fetchData();
    
    if (decryptedId?.subWfId) {
      dispatch(fetchWorkflow(decryptedId.subWfId));
    }
    dispatch(clearValidateTriggered()); // To clear the validation error when the user clicks on back button or page refresh or next button
  }, [decryptedId?.subWfId]);
  
  const sectionFields=[]
  wfJourney?.map((item)=>{
   if(item?.module_name=="Dynamic Forms") {
  // dispatch(setActiveStepOrder(item?.step))
  item?.form_structure?.sections?.map((ele)=>{
    if(ele.order==blockSection)
    {
     ele?.form_groups?.map((group)=>{
      if(group.order==blockGroup){
      const formElement=group.form_elements
      
     formElement?.map((data)=>{
      if(data.type=="recursive"){
      
        var name=data.name
        var label=data.title
      
        sectionFields.push({name,label})
      }else{
     if(data.input_fields){
      data.input_fields?.map((data)=>{
        var name=data.name
        var label=data.label
        sectionFields.push({name,label})
      })
     }
      
     else{
      var name=data.name
      var label=data.label
      sectionFields.push({name,label})
     }
    }
     })
    }
  })

    }
  })
  
   }
   
  })
 


  const IndirectEval = (evalString) => {
    // const selectedData = useSelector((state)=>state.formData.selectedData)
    return eval(evalString);
  };


  useEffect(() => {
    if (
      requestedId &&
      decryptedId &&
      decryptedId.userId &&
      decryptedId.primaryWorkflowId &&
      decryptedId.subWfId && 
      maxActiveSection
    ) {
      const data = {
        primaryWorkflowId: decryptedId.primaryWorkflowId,
        userId: decryptedId.userId,
        subWfId: decryptedId.subWfId,
        requestedId: requestedId,
      };
      if (read_mode && read_mode == "true") {
        dispatch(setIsViewMode(true));
      } else {
        dispatch(setIsViewMode(false));
      }
      dispatch(getRequestedDocByReqId(data));
    } else {
      dispatch(clearRequestedDocs());
    }
  }, [requestedId, maxActiveSection, decryptedId]);

  useEffect(() => {
    const fetchData = async() =>{
    if (Object.keys(requestedDocs).length > 0) {
      // setting the active group and section from the requested docs
      // setInterval(() => {
        if(read_mode && read_mode === "true"){
          dispatch(changeActiveGroup(requestedDocs?.active_group));
          dispatch(changeActiveSection(requestedDocs?.active_section));
          return ;
        }
        // console.log('requestedDocs,', requestedDocs,{userId})
        // if (
        //   userToken?.userOrg &&
        //   organisation_id &&
        //   requestedDocs.updateRequestedBy !== userId &&
        //   (verifiedModules ? !verifiedModules?.edit : true)
        // ) {
        //   navigate("/error");
        // }
      if (requestedDocs?.active_group && requestedDocs?.active_section) {
        if (requestedDocs?.is_active) {
          // if the requested docs is active then set the active group and section else redirect to the success page
          dispatch(changeActiveGroup(requestedDocs?.active_group));
          dispatch(changeMaxActiveGroup(requestedDocs?.active_group));
          dispatch(changeActiveSection(requestedDocs?.active_section));
          dispatch(changeMaxActiveSection(requestedDocs?.active_section));
        } else {
          // if the requested docs is not active then redirect to the success page
          // it signifies that the user has already updated the requested changes
          const stateData = {
            content_trigger:{
            trigger:"UpdatedRequestedChanges"
            },
            organisation_id:organisation_id
          };
          let encryptedData =  await encrypt(stateData)
            sessionStorage.setItem("stateData", JSON.stringify(encryptedData));
            navigate("/update-successful");
          
        }
      }
    }
  }
  fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestedDocs]);

  // Role based control for different users from here
  useEffect(() => {
    const fetchRolesAndCheckAccess = async () => {
      let module_info;
      let userId = JSON.parse(localStorage.getItem("userToken"));
      let query_params = {
        role_id: userId?.role,
        organisation_id: organisation_id
      };
        const result = await dispatch(getRolesInfo(query_params)).unwrap();
        if (result) {
          module_info = result?.module_list.filter((item) => item?.module_id == config?.detailview_module_id);
        }
        if (userId && userDetail?.created_by ) {
          if (userId?.userId != userDetail?.created_by && userId?.userId !== userDetail?.source_data?.internal_poc_user_id && !module_info?.[0]?.edit) {
            navigate("/error");
          }
        }
    };
    fetchRolesAndCheckAccess();
  }, [userDetail]);
  

  

  // Mobile Responsivess - conditions - start
  const checkWindowWidth = () => {
    const width = window.innerWidth;
    if (width < 640 && !isMobile) {
      setIsMobile(true);
    } else if (width > 640 && isMobile) {
      setIsMobile(false);
    }
  };

  window.addEventListener("resize", () => checkWindowWidth());

  // Mobile Responsivess - conditions - end

  useEffect(() => {
    checkWindowWidth();
  }, []);

  useEffect(() => {
  if (!config?.wf_journey?.find(item => (item?.module_name === 'Dynamic Forms')))
  dispatch(setConfigLoading(true))
  if (decryptedId?.redirectionConfigId) {
    dispatch(setConfigurationId(decryptedId?.redirectionConfigId));
    dispatch(setDynamicConfigId(decryptedId?.redirectionConfigId));
    dispatch(setUserInitiatedRequired(IndirectEval(user_initiated)))
    dispatch(changeMaxActiveSection(1))
    dispatch(changeMaxActiveGroup(1))
    dispatch(getConfiguration(decryptedId?.redirectionConfigId));
  }
  }, [decryptedId?.redirectionConfigId]);





  // useEffect(() => {
  //   if (userToken && loggedInUserInfo && organisation_id) {
  //     if(verifiedModules ?  !verifiedModules?.edit : true){
  //       navigate("/error");
  //     }
  //     if (
  //       logged_in_user_organisation_id &&
  //       organisationIdOfUser &&
  //       String(logged_in_user_organisation_id) !== String(organisationIdOfUser) 
  //     ) {
  //       navigate("/error");
  //     }
  //   }
  // }, [userToken, loggedInUserInfo, verifiedModules,organisationIdOfUser,organisation_id]);

  // Increment the step_order from redux to change the main form
  //   let activeStepOrder = 1;

 
  // config?.wf_journey?.map((item) => {
  //   activeStepOrder = 1;
  //   if (item?.step === activeStepOrder) {
  //     console.log("item?.step------------------------------------",item?.step);
  //     formStructure = { ...item?.form_structure };
  //   }
  //   return;
  // })


  config?.wf_journey?.forEach((item) => {
    if (item?.module_name === 'Dynamic Forms'  && item?.step == (activeStepOfUser ||  activeStepOrder)) {
      formStructure = { ...item?.form_structure };
      return
    } else if (item?.module_name === 'Dynamic Forms' && item?.step !== activeStepOfUser && item?.current_activity === currentStep?.status) {
      for (let i = activeStepOfUser - 1; i >= 1; i--) {
        const previousStep = config?.wf_journey.find((item) => item?.step === i);
        if (previousStep?.module_name === 'Dynamic Forms') {
          formStructure = { ...previousStep?.form_structure };
          break;
        }
      }
    }
  });

  

  banner = formStructure?.sections?.filter((item) => item?.type === "banner");
  //getting the next and prev steps
  formStructure?.sections?.forEach((item, index) => {
    let dynamicFormType = null;
    sections[item?.order] = {
      title: item?.title,
      show_form_stepper : item?.show_form_stepper,
      payment_id : item?.payment_id,
      payment_status : item?.payment_status,
      form_groups: item?.form_groups?.map((_item, _index) => {
        _item?.form_elements.map((fields) => {
          if(formComponents.includes(fields?.type)) {
            dynamicFormType = fields.type
          }
        })
        return {
          name: _item?.name,
          title: _item?.title,
          group_order: _item?.order,
          display_group: _item?.show,
          group_length: item?.form_groups?.length,
          show: _item?.show,
          form_elements: _item?.form_elements,
          form_buttons: _item?.form_buttons,
          show_application_to : _item?.show_application_to
        };
      }),
      component_type: dynamicFormType,
      section_order: item?.order,
      section_status:item?.status,
      restricted_view:item?.restricted_view ? item?.restricted_view : false,
      element_number: index,
      display_section: item?.show,
    };
  });

  const getNextGroup = (item) => {
    if (item.group_order + 1 > item?.group_length) {
      return null;
    }
    return item.group_order + 1;
  };

  // config dependencies has to checked .... ? 
  useEffect(() => {
    Object.values(sections).map(async(item,index) => {
      let sectionValue = {...sections};
      if(formComponents.includes(item?.component_type)){
        let response = await getFormComponents({component_type: item?.component_type})
        let newSections = {...sections[index + 1]};
        let form_element;
        let form_group;
        newSections?.form_groups.map((_item) => {
          form_group = {
            ..._item,
          }
          _item.form_elements.map((fields) => {
            form_element = {
              ...fields,
              input_fields: response?.form_elements?.input_fields
            }
          })
        })
        form_group["form_elements"] = [form_element];
        newSections["form_groups"] = [form_group];
        sectionValue[index+1] = newSections;
        dispatch(setSections(sectionValue));
      } else dispatch(setSections(sections));
    })
    dispatch(setBanner(banner));
    dispatch(setFormOccupancy(formStructure.form_occupancy))
    dispatch(setNavOrientation(formStructure.nav_orientation))
    if (formStructure.layout === "regular") dispatch(setStepperDisplay(false));
    else dispatch(setStepperDisplay(true));
  }, [config,requestedDocs?.active_group , requestedDocs?.active_section]);


  const prepareAndRedirectToPayment = async (paymentID) => {
    if(paymentID){

    }
    const { userId, paymentID: encryptedPaymentID } = await encryptURLParams({
      userId:
        decryptedId?.userId === selectedData?.user_id
          ? decryptedId?.userId
          : selectedData?.user_id, // / as I am stacking up the users based on the userId present in the workflow , the problem arises when internalUser is logged in and his userId is different from th existing userId in the workflow which is causing an issue in payment updation
      paymentID,
    });
  
    const stateData = {
      header: "Payment",
      message: "Please wait while we redirect you to the payment gateway",
      buttonText: "Done",
      organisation_id: organisation_id,
    };
  
    sessionStorage.setItem("stateData", JSON.stringify(stateData));
    // clearing selected data while routing to payment page as workflow data is irrelevant to payment
    dispatch(clearSelectedData({}))
  
    navigate(`/payment/${encryptedPaymentID}/${userId}`, {
      replace: false,
      state: stateData,
    });
    // adding a reload here because few state variables are getting updated post navigate is called which is causing the cursor to
    // stay in same page and its going infinite loop
    window.location.reload();
    setIsRoutingToPaymentObject((prevState) => ({
      ...prevState,
      isRoutingToPayment: false,
    }));
  };
  
  const redirectToPayment = async (
    paymentIdKey,
    paymentIdObj,
    paymentIDGenerated
  ) => {
    const paymentId = paymentIdObj?.[paymentIdKey];

    if (paymentIDGenerated) {
      await prepareAndRedirectToPayment(paymentIDGenerated);
      isPAymentIDCreationInProgress.current = false;
    }
    if (paymentId) {
      const currentPaymentInfo = await dispatch(
        getPaymentAndUserInfo({
          payment_id: paymentId,
          user_id: decryptedId?.userId,
        })
      ).unwrap()

      if(parseFloat(currentPaymentInfo?.pending_amount) === 0) return

      await prepareAndRedirectToPayment(paymentId);
      isPAymentIDCreationInProgress.current = false;
    }
  };
  
  const navigateIfCoApplicantsYetToFillForm = async () => {
    const { userId, subWfId, primaryWorkflowId } = await encryptURLParams({
      userId: decryptedId?.userId,
      subWfId: decryptedId?.subWfId,
      primaryWorkflowId: decryptedId?.primaryWorkflowId,
    });
  
    const stateData = {
      header: "Form to be filled by all users",
      content: "Please wait until all users are yet to fill the form",
      buttonText: "Ok",
      organisation_id: organisation_id,
    };
    sessionStorage.setItem("stateData", JSON.stringify(stateData));
    navigate(
      `/payment-confirmation/${primaryWorkflowId}/${subWfId}/${userId}`,
      {
        state: stateData,
      }
    );
    return;
  };
  
  const findPaymentIdObject = (primaryUser, paymentIdKey) => {
    return Array.isArray(primaryUser?.payment_ids) &&
      primaryUser?.payment_ids?.length &&
      primaryUser?.payment_ids?.find((item) =>
        item?.hasOwnProperty(paymentIdKey)
      );
  }
  
  const findUserSubWorkflow = (primaryUser, decryptedId) => {
    return primaryUser?.source_data?.subworkflows?.find(
      (applicant) =>
        applicant?.user_id?.toString() === decryptedId?.userId &&
        applicant?._id?.toString() === decryptedId?.subWfId
    );
  }
  
  useEffect(() => {
    const paymentIdKey = stepperSections?.[activeSection]?.payment_id;
    const paymentIdObj = findPaymentIdObject(primaryUser, paymentIdKey);

    const userToken= JSON.parse(localStorage.getItem("userToken"))
  
    if (stepperSections?.[activeSection]?.payment_id && payment_ids && !userToken) {
      setIsRoutingToPaymentObject((prevState) => ({
        ...prevState,
        isRoutingToPayment: false,
      }));
      isPAymentIDCreationInProgress.current = false;
      redirectToPayment(paymentIdKey, paymentIdObj);
    }
  
    if (primaryUser?.source_data?.subworkflows?.length > 1 && decryptedId) {
      const userSubWorkFlow = findUserSubWorkflow(primaryUser, decryptedId);

      if (
        userSubWorkFlow?.payment_status &&
        stepperSections?.[activeSection]?.["payment_status"] &&
        userSubWorkFlow?.payment_status ===
          stepperSections?.[activeSection]?.["payment_status"] &&
        !isRoutingToPaymentObject?.isGenerationOfPaymentIDInProgress &&
        !isPAymentIDCreationInProgress
      ) {
        navigateIfCoApplicantsYetToFillForm();
      }
    }
  
    if (
      stepperSections?.[activeSection]?.payment_id !== undefined &&
      primaryUser?.source_data?.subworkflows?.length > 1 &&
      primaryUser?.configuration_id &&
      !payment_ids &&
      decryptedId?.subWfId &&
      decryptedId?.primaryWorkflowId &&
      decryptedId?.userId &&
      !isPAymentIDCreationInProgress
    ) {
      navigateIfCoApplicantsYetToFillForm();
    }
  }, [
    payment_ids,
    primaryUser,
    stepperSections[activeSection],
    decryptedId,
    // navigate,
    activeGroup,
    activeSection,
  ]);

  const handleSkip = () => {
    let formattedData = { ...selectedData };

    let selectedSection = sections[activeSection];
    let selectedGroup = selectedSection?.form_groups?.find(
      (item) => item.group_order == activeGroup
    );
    let nextStep = getNextGroup(selectedGroup);

    formattedData.active_section = activeSection;
    formattedData.active_group = nextStep;

    if (nextStep === null) {
      let nextMainStep = selectedSection?.section_order + 1;
      let nextSubStep = 1;
      formattedData.active_section = nextMainStep;
      formattedData.active_group = nextSubStep;
      // formattedData.max_active_section = maxActiveSection
      // formattedData.max_active_group = maxActiveGroup
    }

    if (formattedData.active_section > maxActiveSection) {
      formattedData.max_active_section = formattedData.active_section;
      formattedData.max_active_group = formattedData.active_group;
    } else if (activeSection == maxActiveSection) {
      if (formattedData.active_group > maxActiveGroup) {
        formattedData.max_active_group = formattedData.active_group;
        formattedData.max_active_section = formattedData.active_section;
      }
    } else {
      formattedData.max_active_section = maxActiveSection;
      formattedData.max_active_group = maxActiveGroup;
    }

    let signer_data = []
      if(isSignerRecursion  && recursive?.signerParams?.signer_validation_name){
        // signer_data = getAllSignerId(config?.wf_journey[0]?.form_structure?.sections)
        signer_data = [...recursive?.signerParams?.signer_validation_name,arrayName]
      }

    let payload;
    if (saveData && saveData.length) {
      let isRecursiveData = 'true';
      let fieldNames = formFields.map((item, index) => {
        return item.name;
      });

      fieldNames?.map((item) => {
        delete formattedData[item];
      });

      let recursiveData = {};
      recursiveData[arrayName] = saveData;
      dispatch(clearSaveData());
      payload = createUserWorkflowPayload(
        formattedData,
        recursiveData,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        isSignerRecursion,
        signer_data,
        documents,
        deleteDocument,
        null,
        selectedSection.section_order
      );
    } else {
      payload = createUserWorkflowPayload(
        formattedData,
        null,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        isSignerRecursion,
        signer_data,
        documents,
        deleteDocument,
        selectedSection.section_order
      );
    }

    if (payload) {
      let formattedpayload = {
        ...payload,
        userId: decryptedId?.subWfId,
        section_order: selectedSection?.section_order,
        section_status: selectedSection?.section_status ?? "In Draft",
      };

      dispatch(updateWorkflowInfo(formattedpayload));
    }
    dispatch(setIsSignerRecursion(false))
    dispatch(cleardeleteDocument())
    dispatch(clearSignerParams())
  };

  let loggedInUserName = loggedUserId ? (`${(loggedInUserInfo?.profileInfo?.first_name || "") + " " + (loggedInUserInfo?.profileInfo?.last_name || "")}` ) : "";
  let loggedInUserEmail=loggedUserId && loggedInUserInfo?.profileInfo?.emailId  
  let loggedInUserMobileNumber = loggedUserId && loggedInUserInfo?.profileInfo?.mobileNumber

  
  const handleNext = async (params) => {
    // when params.params?.skipUpdateNextStepForPayment is true, it means that the user is redirected to the payment page and to show the loader
    if(params?.setLoadingToTrue){
      setIsRoutingToPaymentObject((prevState) => ({
        ...prevState,
        isRoutingInternalUserAsHeCannotPay: params?.setLoadingToTrue,
      }));
    }

    if (currentStep?.name === "workflows_generation"  ) {
      let payload = { ...selectedData };
      let recursiveData = {};
      recursiveData[arrayName] = saveData;
      let order = activeStepOrder;
      let applicantData;
      let uniqueName = config?.application_sequence ? config?.application_sequence :  config?.wf_name
      let application_ref_id = uniqueWorkFlowId(uniqueName)
      let applicant_sequence = config?.application_sequence
      let user_hierarchy =  config?.user_hierarchy
      finalPayload = await createMasterDataPayload(
        dynamic_wf,
        payload,
        organisation_id,
        configurationId,
        saveData,
        isEmailVerified,
        isMobileVerified,
        null,
        email,
        recursiveFormData,
        order,
        dynamicConfigId,
        application_ref_id,
        loggedUserId,
        applicant_sequence,
        loggedInUserName,
        loggedInUserEmail,
        loggedInUserMobileNumber,
        recursiveData,
        null,
        null,
        user_initiated,
        null,
        null,
        user_hierarchy
      );
      dispatch(setShowDataPreview(false));
      setIsCreateWorkFlowLoading(true);
        // applicantData = await createSubWorkFlow(finalPayload);
        // let sub_id =applicantData?.userFormInfo?.insertedIds[0];
        let formattedData = { ...selectedData,last_login_at:new Date() };
        let selectedSection = stepperSections[activeSection];
        let selectedGroup = selectedSection?.form_groups?.find(
        (item) => item.group_order == activeGroup
        );
       let nextStep = getNextGroup(selectedGroup);

       formattedData.active_section = activeSection;
       formattedData.active_group = nextStep;

       if (nextStep === null) {
       let nextMainStep = selectedSection?.section_order + 1;
       let nextSubStep = 1;
       formattedData.active_section = nextMainStep;
       formattedData.active_group = nextSubStep;
       }

      if (formattedData.active_section > maxActiveSection) {
      formattedData.max_active_section = formattedData.active_section;
      formattedData.max_active_group = formattedData.active_group;
      } else if (activeSection == maxActiveSection) {
      if (formattedData.active_group > maxActiveGroup) {
        formattedData.max_active_group = formattedData.active_group;
        formattedData.max_active_section = formattedData.active_section;
      }
      } else {
      formattedData.max_active_section = maxActiveSection;
      formattedData.max_active_group = maxActiveGroup;
      }
      finalPayload = await createMasterDataPayload(
        dynamic_wf,
        payload,
        organisation_id,
        configurationId,
        saveData,
        isEmailVerified,
        isMobileVerified,
        null,
        email,
        recursiveFormData,
        order,
        dynamicConfigId,
        application_ref_id,
        loggedUserId,
        applicant_sequence,
        loggedInUserName,
        loggedInUserEmail,
        loggedInUserMobileNumber,
        recursiveData,
        null,
        null,
        user_initiated,
        formattedData,
        null,
        user_hierarchy
      );
      dispatch(setShowDataPreview(false));
     
     if(currentStep?.show_application_to && currentStep?.show_application_to == 'user_hierarchy' && userId){
       finalPayload['show_application_to'] = userId
     }
     if(queryPath){
      //Changed Key physical_form to verification
      finalPayload.verification = true
    } else if (!queryPath) {
      finalPayload.verification = is_verified
    }
    
    const sub_length= finalPayload?.source_data?.subworkflows?.length;
    setIsCreateWorkFlowLoading(true);
      if(sub_length>1){
         applicantData = await createPrimaryWorkFlow(finalPayload);
       }else{
         applicantData = await createSubWorkFlow(finalPayload);
        }
      if (loggedUserId) {
        if(!queryPath){
          const stateData = {
            content_trigger:params?.content_trigger,
            organisation_id:organisation_id
          };
          let encryptedData =  await encrypt(stateData)
            sessionStorage.setItem("stateData", JSON.stringify(encryptedData));
            navigate(`/dashboard/form/${redirectionConfigId}/update-successful` );
          
        } else if(queryPath) {
            handleRedirect(applicantData?.link)
           setIsCreateWorkFlowLoading(false);
        }
      } 
      else if (!loggedUserId) {
      handleRedirect(applicantData?.link)
      setIsCreateWorkFlowLoading(false);
      }
      dispatch(clearSaveData());
      dispatch(clearShowData());
      // dispatch(setRecursiveSection(false))
      dispatch(incrementActiveStepOrder(IndirectEval(currentStep.next_step)));
     }else{
      let formattedData = { ...selectedData,last_login_at:new Date() };
      if(IndirectEval(params?.auto_fill_trigger)){
        let data = autoFillData(params?.autofill,selectedData)
        if(data){
          formattedData = {...formattedData,...data} ;
        }
      }
      let selectedSection = stepperSections[activeSection];
      let selectedGroup = selectedSection?.form_groups?.find(
        (item) => item.group_order == activeGroup
      );
      let nextStep = getNextGroup(selectedGroup);
  // when params?.skipUpdateNextStepForPayment is true, it means that the user is redirected to the payment page
  //  or if he is an internal user then he will redirected to a page where we state saying 
  //  "internal user cannot do the payment and the next step should not be updated in the database"
      formattedData.active_section =params?.skipUpdateNextStepForPayment ? formattedData?.active_section || 1 :  activeSection;
      formattedData.active_group =params?.skipUpdateNextStepForPayment ? formattedData?.active_group || 1: nextStep;
  
      if (nextStep === null) {
        let nextMainStep = selectedSection?.section_order + 1;
        let nextSubStep = 1;
        formattedData.active_section =params?.skipUpdateNextStepForPayment ? formattedData?.active_section : nextMainStep;
        formattedData.active_group =params?.skipUpdateNextStepForPayment ? formattedData.active_group: nextSubStep;
      }
  
      if (formattedData.active_section > maxActiveSection) {
        formattedData.max_active_section = formattedData.active_section;
        formattedData.max_active_group = formattedData.active_group;
      } else if (activeSection == maxActiveSection) {
        if (formattedData.active_group > maxActiveGroup) {
          formattedData.max_active_group = formattedData.active_group;
          formattedData.max_active_section = formattedData.active_section;
        }
      } else {
        formattedData.max_active_section = maxActiveSection;
        formattedData.max_active_group = maxActiveGroup;
      }
  
      let payload;
      let declarationobjects;
      if(consentType && consentId && consentText) {
        declarationobjects = {
          consent_type: consentType,
          consent_id: consentId,
          consent_text: consentText,
          approved_at: moment(new Date()),
        }
      } else declarationobjects = null;
      if (saveData && saveData.length) {
        let signer_data = []
        if(isSignerRecursion && recursive?.signerParams?.signer_validation_name){
          // signer_data = getAllSignerId(config?.wf_journey[0]?.form_structure?.sections)
          signer_data = [...recursive?.signerParams?.signer_validation_name,arrayName]
        }
        let isRecursiveData = 'true';
        let recursiveData = {};
        recursiveData[arrayName] = saveData;
        dispatch(clearSaveData());
        dispatch(clearShowData());
        payload = createUserWorkflowPayload(
          formattedData,
          recursiveData,
          uploadedDocument,
          selectedQuestion,
          questionData,
          questionnaireId,
          isSignerRecursion,
          signer_data,
          documents,
          deleteDocument,
          evaluationRule,
          isRecursiveData,
          selectedSection.section_order

        );
      } else if (savedFormData && savedFormData.length) {
        let recursiveData = {};
        recursiveData[fieldRecursiveName] = savedFormData;
        payload = createUserWorkflowPayload(
          formattedData,
          recursiveData,
          uploadedDocument,
          selectedQuestion,
          questionData,
          questionnaireId,
          isSignerRecursion,
          saveData,
          documents,
          deleteDocument,
          evaluationRule,
          selectedSection.section_order
        );
      } else {
        payload = createUserWorkflowPayload(
          formattedData,
          null,
          uploadedDocument,
          selectedQuestion,
          questionData,
          questionnaireId,
          null,
          null,
          documents,
          deleteDocument,
          evaluationRule,
          null,
          declarationobjects,
          selectedSection.section_order

        );
      }
  
      if ((decryptedId?.subWfId || decryptedId?.primaryWorkflowId) && payload) {
        let formattedpayload = {
          ...payload,
          userId: decryptedId?.subWfId,
          section_order: selectedSection?.section_order,
          section_status: selectedSection?.section_status ?? "In Draft",
        };
        let statusUpadte = {
          status: params?.status_to_update,
          applicant_id:decryptedId?.subWfId
        };
        // should make the changes here as its only handle next it should request to update the status irrespective of loggedUserId
        if (params?.status_to_update && !loggedUserId) {
          dispatch(updateApplicantStatusAndSubWorkflowStatus(statusUpadte));
        }
        !params?.skipUpdateNextStepForPayment &&
          dispatch(updateWorkflowInfo(formattedpayload));
        // commented below code as it was causing some issue during status update.


        
        // If the internal user is making a payment, the intermediate status is updated to of payment dynamically. This only applies to the payment module, indicated by "params?.skipUpdateNextStepForPayment" being true.
        // so I am updating the status irrespective of whether the user is logged in or not
        if (params?.status_to_update && params?.skipUpdateNextStepForPayment) {
          // the below two APIcalls are triggered only when params?.skipUpdateNextStepForPayment is true and I am awaiting this call to finish before I move to the payment and this will behanve thbis way only for the handlePaymentInitiation function
          await dispatch(
            updateApplicantStatusAndSubWorkflowStatus(statusUpadte)
          ).unwrap();
          await dispatch(updateWorkflowInfo(formattedpayload)).unwrap();
        }

        if(params?.setLoadingToTrue){
          setIsRoutingToPaymentObject((prevState) => ({
            ...prevState,
            isRoutingInternalUserAsHeCannotPay: false,
          }));
        }

        //ROLE based notification
        // TODO email based on step update config
        const module_settings = params?.module_settings

        if (
          module_settings &&
          Object.keys(module_settings)?.length &&
          module_settings?.triggerRoleBasedEmail
        ) {
          const emailTRiggerPayload = {
            ...module_settings?.payment_settings,
            primaryWorkflowId: decryptedId?.primaryWorkflowId,
            subWfID: decryptedId?.subWfId,
            loggedInUserId: loggedUserId,
          };

          dispatch(sendEmailsBasedOnRoleOnAction(emailTRiggerPayload)).unwrap();
        }


        //* Reseting Recursive states to default
        dispatch(setIsSignerRecursion(false));
        dispatch(setIsToggled(false));
        dispatch(setConsentConfig())
        dispatch(setShowDataPreview(false));
        dispatch(clearSaveData());
        dispatch(clearShowData());
        dispatch(clearFieldRecursionData());
        dispatch(clearValidateTriggered());
        dispatch(cleardeleteDocument())
        dispatch(clearSignerParams())
      }
    }
 
  };

  const handleSubmit = () => {
    let formattedData = { ...selectedData };
    let selectedSection = sections[activeSection];
    let selectedGroup = selectedSection?.form_groups?.find(
      (item) => item.group_order == activeGroup
    );
    let nextStep = getNextGroup(selectedGroup);

    formattedData.active_section = activeSection;
    formattedData.active_group = nextStep;

    if (nextStep === null) {
      let nextMainStep = selectedSection?.section_order + 1;
      let nextSubStep = 1;
      formattedData.active_section = nextMainStep;
      formattedData.active_group = nextSubStep;
    }

    if (formattedData.active_section > maxActiveSection) {
      formattedData.max_active_section = formattedData.active_section;
      formattedData.max_active_group = formattedData.active_group;
    } else if (activeSection == maxActiveSection) {
      if (formattedData.active_group > maxActiveGroup) {
        formattedData.max_active_group = formattedData.active_group;
        formattedData.max_active_section = formattedData.active_section;
      }
    } else {
      formattedData.max_active_section = maxActiveSection;
      formattedData.max_active_group = maxActiveGroup;
    }

    let payload;
    if (saveData && saveData.length) {
      // let fieldNames = formFields.map((item, index) => {
      //   return item.name
      // })

      // fieldNames?.map(item => {
      //   delete formattedData[item]
      // })
      let signer_data = []
      if(isSignerRecursion  && recursive?.signerParams?.signer_validation_name){
        // signer_data = getAllSignerId(config?.wf_journey[0]?.form_structure?.sections)
        signer_data = [...recursive?.signerParams?.signer_validation_name,arrayName]
      }
      let isRecursiveData = 'true';
      let recursiveData = {};
      recursiveData[arrayName] = saveData;
      dispatch(clearSaveData());
      dispatch(clearShowData());
      payload = createUserWorkflowPayload(
        formattedData,
        recursiveData,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        isSignerRecursion,
        signer_data,
        documents,
        deleteDocument,
        null,
        isRecursiveData
      );
    } else {
      payload = createUserWorkflowPayload(
        formattedData,
        null,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        null,
        null,
        documents,
        deleteDocument
      );
    }

    if (payload) {
      let formattedpayload = {
        ...payload,
        userId: decryptedId.subWfId,
        user_initiated_flow: true,    //Changed Key isRMFlow to user_initiated_flow
        requestedId: requestedId,
      };

      dispatch(updateWorkflowInfo({ formattedpayload }));
      //* Reseting Recursive states to default
      dispatch(setIsSignerRecursion(false));
      dispatch(setIsToggled(false));
      dispatch(setShowDataPreview(false));
      dispatch(cleardeleteDocument())
      dispatch(clearSignerParams())
    }
  };

  const handleUpdateRequestedChanges = (data) => {
    let formattedData = { ...selectedData };
    if(data){
      formattedData = { ...formattedData,...data }
    }
    delete formattedData?.workflow_documents
    delete formattedData?.conversion_file_requests
    
    let payload;
    if (saveData && saveData.length) {
      let signer_data = []
      if(isSignerRecursion  && recursive?.signerParams?.signer_validation_name){
        // signer_data = getAllSignerId(config?.wf_journey[0]?.form_structure?.sections)
        signer_data = [...recursive?.signerParams?.signer_validation_name,arrayName]
      }
      let isRecursiveData = 'true';
      let recursiveData = {};
      recursiveData[arrayName] = saveData;
      dispatch(clearSaveData());
      dispatch(clearShowData());
      payload = createUserWorkflowPayload(
        formattedData,
        recursiveData,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        isSignerRecursion,
        signer_data,
        documents,
        deleteDocument,
        null,
        isRecursiveData
      );
    } else {
      payload = createUserWorkflowPayload(
        formattedData,
        null,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        null,
        null,
        documents,
        deleteDocument
      );
    }
    if (payload) {
      let formattedpayload = {
        ...payload,
        userId: decryptedId?.subWfId,
        user_initiated_flow: true,     //Changed Key isRMFlow to user_initiated_flow
        requestedId: requestedId,
        selectedfield:sectionFields
      };

      dispatch(updateWorkflowInfo(formattedpayload));
      dispatch(cleardeleteDocument())
    }
  };
  
  const updateRoutingToPaymentObject = (value) => {
    setIsRoutingToPaymentObject((prevState) => ({
      ...prevState,
      isGenerationOfPaymentIDInProgress: value,
    }));
  };
  
  const handlePaymentInitiation = async ({
    paymentPayload,
    triggerPaymentCreation,
    amount
  }
  ) => {
    dispatch(setIsCreatingPayment(true))
    isPAymentIDCreationInProgress.current = true;

    const paymentInitiationAlreadyDone = isPaymentInitiationAlreadyDone(
      primaryUser,
      paymentPayload
    );
    const paymentTransactionId =
      paymentInitiationAlreadyDone?.[paymentPayload?.payment_id];

      let pending_amount = null

    if (paymentTransactionId) {
       pending_amount = await dispatch(
        getPaymentAndUserInfo({
          payment_id: paymentTransactionId,
          user_id: decryptedId.userId,
        })
      ).unwrap();

      
    }

    // const isPendingAmountUndefinedOrNull =
    //   pending_amount?.pending_amount === null ||
    //   pending_amount?.pending_amount === undefined;
    // const calculatedAmount = eval(amount) || eval(paymentPayload.total_amount);
    // const minimumPaymentAmount = paymentPayload?.minimum_payment_amount || 1;

    // if (
    //   (isPendingAmountUndefinedOrNull && Number(calculatedAmount) === 0) ||
    //   (isPendingAmountUndefinedOrNull &&
    //     calculatedAmount < minimumPaymentAmount)
    // ) {
    //   handlePaymentFailure(paymentPayload, organisation_id, decryptedId, true);
    //   isPAymentIDCreationInProgress.current = false;
    //   updateRoutingToPaymentObject(false);
    //   dispatch(setIsCreatingPayment(false));
    //   return;
    // }


    await handleNext({
      status_to_update: paymentPayload?.payment_status,

      setLoadingToTrue: true,
      skipUpdateNextStepForPayment:
        parseFloat(pending_amount?.pending_amount) !== 0,
    }); // to show the loader and not to update the next step in the database, inturn will update the intermediate payment status

    const internalUserPayment = paymentPayload?.internal_user_payment;
    if (
      !triggerPaymentCreation ||
      isPaymentInitiationAlreadyDone(primaryUser, paymentPayload)
    ) {
      await handleExistingPayment(
        primaryUser,
        paymentPayload,
        organisation_id,
        decryptedId,
        internalUserPayment // this flag determines whether internalUser can perform payment or not
      );

      updateRoutingToPaymentObject(false);
      dispatch(setIsCreatingPayment(false));
      isPAymentIDCreationInProgress.current = false;
      return;
    }

    const { primaryWorkflowId, subWfId, userId } = decryptedId;

    try {
      await updatePaymentStatus(
        paymentPayload,
        primaryWorkflowId,
        subWfId,
        userId === selectedData?.user_id ? userId : selectedData?.user_id // as I am stacking up the users based on the userId present in the workflow , the problem arises when internalUser is logged in and his userId is different from th existing userId in the workflow which is causing an issue in payment updation
      );
    } catch (error) {
      dispatch(setIsCreatingPayment(false));
      console.error("Failed to update payment status:", error);
      return;
    }
  
    const usersListKeys = getUsersListKeys(paymentPayload);
    const usersList = getUsersList(primaryUser, paymentPayload, usersListKeys);
  
    const paymentInitiationPayload = {
      payment_mode: paymentPayload.payment_mode,
      payment_type: paymentPayload.payment_type,
      total_amount: eval(amount) || eval(paymentPayload.total_amount),
      user_list: usersList,
      organisation_id: organisation_id,
      sequence: paymentPayload.sequence,
      notification: paymentPayload?.payment_settings || [],
    };

    const userToken = JSON.parse(localStorage.getItem("userToken"));

  
    const payload = {
      paymentInitiationPayload,
      primaryWorkflowId,
      paymentStatus: paymentPayload.payment_status,
      payment_id: paymentPayload.payment_id,
      configuration_id: paymentPayload?.configuration_id,
      status_after_payment: paymentPayload?.status_after_payment,
      payment_status_after_payment:
        paymentPayload?.payment_status_after_payment,
      active_step_for_payment: paymentPayload?.active_step_for_payment,
      workflow_step_update: paymentPayload?.workflow_step_update,
      suppress_user_email: paymentPayload?.suppress_user_email,
      disable_partial: paymentPayload?.disable_partial,
      triggered_by_internal_user: !!(
        userToken && Object.keys(userToken)?.length
      ),
      internal_user_id:
        userToken && Object.keys(userToken)?.length && userToken?.userId,
      active_section_after_payment:
        paymentPayload?.active_section_after_payment,
      active_group_after_payment: paymentPayload?.active_group_after_payment,
    };

    try {

      const response = await dispatch(initiatePayment(payload)).unwrap();

      if (isPaymentFailure(response)) {
        handlePaymentFailure(paymentPayload, organisation_id, decryptedId);
        isPAymentIDCreationInProgress.current = false;
        updateRoutingToPaymentObject(false);
        dispatch(setIsCreatingPayment(false));
        return;
      }

      if (
        response?.status === "success" &&
        response?.message?.toLowerCase() ===
          "payment id generated successfully" &&
        Array.isArray(response?.data) &&
        response?.data?.length &&
        response?.paymentModuleID
      ) {
        try {
          await redirectToPayment("", "", response?.paymentModuleID);
        } catch (error) {
          console.error("Failed to navigate to payment:", error);
        }
        updateRoutingToPaymentObject(false);
        dispatch(setIsCreatingPayment(false));
      }
      isPAymentIDCreationInProgress.current = false;
    } catch (error) {
      console.error("Failed to initiate payment:", error);
    }
  };

  const isPaymentInitiationAlreadyDone = (primaryUser, paymentPayload) => {
    return primaryUser?.payment_ids?.find((payment) =>
      payment.hasOwnProperty(paymentPayload.payment_id)
    );
  };

  const handleExistingPayment = async (
    primaryUser,
    paymentPayload,
    organisation_id,
    decryptedId,
    internalUserPayment
  ) => {
    const paymentInitiationAlreadyDone = isPaymentInitiationAlreadyDone(
      primaryUser,
      paymentPayload
    );
    const paymentTransactionId =
      paymentInitiationAlreadyDone[paymentPayload.payment_id];

    const { userId, primaryWorkflowId, subWfId } = decryptedId || {};
    const userToken = JSON.parse(localStorage.getItem("userToken"));

    const { encryptedUserId, encryptedPrimaryWorkflowId, encryptedSubWfId } =
      await encryptURLParams({
        encryptedUserId:
          userId === selectedData?.user_id ? userId : selectedData?.user_id, /// as I am stacking up the users based on the userId present in the workflow , the problem arises when internalUser is logged in and his userId is different from th existing userId in the workflow which is causing an issue in payment updation
        encryptedPrimaryWorkflowId: primaryWorkflowId,
        encryptedSubWfId: subWfId,
      });

    let stateData = {
      header: paymentPayload?.payment_in_progress_content?.header,
      content: paymentPayload?.payment_in_progress_content?.content,
      buttonText:
        paymentPayload?.payment_in_progress_content?.buttonText || "Ok",
      organisation_id: organisation_id,
    };

    if (paymentTransactionId) {
      const currentPaymentInfo = await dispatch(
        getPaymentAndUserInfo({
          payment_id: paymentTransactionId,
          user_id: userId,
        })
      ).unwrap();

      if (parseFloat(currentPaymentInfo?.pending_amount) === 0) {
        await handleNext({
          skipUpdateNextStepForPayment:
            parseFloat(currentPaymentInfo?.pending_amount) == 0,
        });
        return;
      }

      if (
        parseFloat(currentPaymentInfo?.pending_amount) > 0 &&
        (internalUserPayment ? true : userToken)
      ) {
        stateData = {
          header:
            paymentPayload?.payment_connot_be_done_by_internal_user?.header,
          content:
            paymentPayload?.payment_connot_be_done_by_internal_user?.content,
          buttonText:
            paymentPayload?.payment_connot_be_done_by_internal_user
              ?.buttonText || "Ok",
          organisation_id: organisation_id,
        };
      }
    }
    const { paymentTransactionId: encryptedPaymentID } = await encryptURLParams(
      {
        paymentTransactionId,
      }
    );

    if (internalUserPayment) {
    // clearing selected data while routing to payment page as workflow data is irrelevant to payment
      dispatch(clearSelectedData({}));
      navigate(`/payment/${encryptedPaymentID}/${encryptedUserId}`, {
        state: stateData,
      });
      // adding a reload here because few state variables are getting updated post navigate is called which is causing the cursor to
      // stay in same page and its going infinite loop
      window.location.reload();
    } else if (userToken) {
      sessionStorage.setItem("stateData", JSON.stringify(stateData));
      navigate(
        `/payment-confirmation/${encryptedUserId}/${encryptedPrimaryWorkflowId}/${encryptedSubWfId}`,
        {
          state: stateData,
        }
      );
    }
  };
  const updatePaymentStatus = async (
    paymentPayload,
    primaryWorkflowId,
    subWfId,
    userId
  ) => {
    const updatePaymentStatusPayload = {
      payment_status: paymentPayload.payment_status,
      primaryWorkflowId,
      subWfId,
      userId:userId === selectedData?.user_id ? userId : selectedData?.user_id,
    };

    await dispatch(
      updatePaymentStatusInSubWorkflow(updatePaymentStatusPayload)
    ).unwrap();
  };

  const getUsersListKeys = (paymentPayload) => {
    const usersListKeys = {};
    paymentPayload?.users_list?.forEach((user) => {
      Object.keys(user).forEach((key) => {
        if (eval(user?.[key]?.required)) {
          usersListKeys[key] = user?.[key]?.value;
        }
      });
    });
    return usersListKeys;
  };

  const getUsersList = (primaryUser, paymentPayload, usersListKeys) => {
    const usersData = primaryUser?.source_data?.subworkflows;
    const usersListExpectedKeys = paymentPayload?.users_list_expected_keys;

    return (
      usersData?.length &&
      usersData?.map((user) => {
        const userObj = {};
        usersListExpectedKeys.forEach((key) => {
          if (usersListKeys.hasOwnProperty(key)) {
            userObj[key] = eval(usersListKeys[key]);
          }
        });
        return userObj;
      })
    );
  };

  const isPaymentFailure = (response) => {
    return (
      response?.status === "failure" &&
      response?.message === "All users are not in the same status"
    );
  };

  const handlePaymentFailure = (
    paymentPayload,
    organisation_id,
    decryptedId,
    failedToHaveMinimumAmount=false
  ) => {
    const stateData = {
      header: failedToHaveMinimumAmount
        ? paymentPayload?.payment_minimum_amount_exception?.header
        : paymentPayload?.payment_all_users_not_in_same_status?.header,
      content: failedToHaveMinimumAmount
        ? paymentPayload?.payment_minimum_amount_exception?.content
        : paymentPayload?.payment_all_users_not_in_same_status?.content,
      buttonText: failedToHaveMinimumAmount
        ? paymentPayload?.payment_minimum_amount_exception?.buttonText
        : paymentPayload?.payment_all_users_not_in_same_status?.buttonText ||
          "Ok",
      organisation_id: organisation_id,
    };
    sessionStorage.setItem("stateData", JSON.stringify(stateData));
    navigate(
      `/payment-confirmation/${decryptedId?.primaryWorkflowId}/${decryptedId?.subWfId}/${decryptedId?.userId}`,
      {
        state: stateData,
      }
    );
  };

  useEffect(() => {
    const fetchData = async() =>{
    if (userInfoUpdatedSuccessfully && requestedId) {
      if (requestedDocs?.requestedFlow === "edit") {
        const redirectURL = `/dashboard-detail/${urlParams.primaryWorkflowId}`;
        const redirectFunction = () => {
          navigate(redirectURL);
        };
        const stateData = {
          content_trigger:{
           trigger:trigger
          },
          organisation_id:organisation_id
        };
        let encryptedData = await  encrypt(stateData)
          sessionStorage.setItem("stateData", JSON.stringify(encryptedData));
          navigate("/update-successful" );
        // navigate to update-successful page but should not be able to go to previous page
      }

      if (requestedDocs?.requestedFlow === "update" || requestedDocs?.requestedFlow === "updateSection") {
        // const redirectTo = `/dashboard-detail/${requestedId}`;
        const stateData = {
          content_trigger:{
            trigger:trigger
          },
            organisation_id:organisation_id
          // userName: "Nishanth",
          // buttonText: "Done",
        }
        let encryptedData = await encrypt(stateData)
          sessionStorage.setItem("stateData", JSON.stringify(encryptedData));
          navigate("/update-successful"); // replace false will not allow to go back to previous page
      }
    }
  }
  fetchData()
  }, [userInfoUpdatedSuccessfully,requestedId]);

  useEffect(() => {
    if (
      typeof activeSection === "number" &&
      activeSection >= 0 &&
      Object.keys(sections).length
    ) {
      if (sections?.[activeSection]?.show_form_stepper) {
        let lengthOfConsenstGreaterThanOne = "";
        sections?.[activeSection]?.form_groups.find((data) =>
          data?.form_elements?.map((consents) => {
            if (consents.type == "consent" && consents.consents?.length > 1) {
              lengthOfConsenstGreaterThanOne = true;
            } else {
              lengthOfConsenstGreaterThanOne = false;
            }
          })
        );
        if (lengthOfConsenstGreaterThanOne) {
          dispatch(setStepperDisplay(true));
        }
      }
    }
  }, [activeSection]);
 
  const handleBack = () => {
    if (dataPreview) {
      dispatch(setShowAddMore(false));
      dispatch(setShowDataPreview(false));
      dispatch(clearSaveData());
      dispatch(clearShowData());
    }
    if (activeGroup == 1) {
      if (activeSection == 1) return;
      let lastSection = getPreviousSection(formStructure?.sections?.slice()?.reverse())
      dispatch(changeActiveSection(lastSection))
      let lastGroup = getPreviousGroup(sections[lastSection]?.form_groups?.slice()?.reverse())
      dispatch(changeActiveGroup(lastGroup));
    } else {
      dispatch(changeActiveGroup(getLastGroup(sections[activeSection]?.form_groups?.slice()?.reverse())));
      dynamicFormScroll();
    }
    setFormErr({})
    dispatch(setIsSignerRecursion(false))
    dispatch(clearSignerParams())
  };

  const getPreviousGroup = (groupArray) => {
    for (const group of groupArray) {
      if (IndirectEval(group.show) === true)
        return group?.group_order
    }
  }

  const getLastGroup = (groupArray) => {
    for (const group of groupArray) {
      if (IndirectEval(group.show) === true && group.group_order < activeGroup) 
        return group?.group_order
    }
  }

  const getPreviousSection = (sectionArray) => {
    for (const section of sectionArray) {
      if (IndirectEval(section.show) === true && section.order < activeSection) 
        return section?.order
    }
  }

  const handleCancel = () => {
    dispatch(setShowAddMore(true));
    showRecursiveForm && dispatch(setShowRecursiveForm(false));
    !showRecursiveForm && dispatch(clearRecursiveFormData());
    dispatch(setIsEditRecursiveForm(false));
    dispatch(cleardeleteRecursiveDocument())
    setFormErr({});
    dispatch(clearValidateTriggered()); // To clear the validation error when the user clicks on back button or page refresh or next button
    dynamicFormScroll();
  };

  
 const handleAdd = () => {
   //made the changes here because index 0 was hardcoded before now made it dynamic
    let formattedFormFields = fields?.filter((data) => data?.type !== "subheader") ?.flatMap((data) => data?.input_fields?.filter((item) => item.type !== "toggle") || []);
    dispatch(setFormFields(formattedFormFields));
    dispatch(setRecursiveActions(fields?.filter((data) => data?.type !== "subheader").recursive_actions));

    let setShowRecursiveData = {},
      saveRecursiveData = {},
      countryCode,
      mobile,
      completeMobileNumber;
      formattedFormFields.map((item, index) => {
      //if condition because the recursiveNameFields might have undefined values
      if (recursiveFormData[item.name] && IndirectEval(item?.show)) {
        saveRecursiveData[item.name] = recursiveFormData[item.name];
        setShowRecursiveData[item.name] = recursiveFormData[item.name];
      }
      if(recursiveFormData?.hasOwnProperty('verification_response')){
          saveRecursiveData['verification_response'] = recursiveFormData['verification_response'];
          dispatch(clearRecursiveFormDataKey({ key: 'verification_response' })) 
        }
    });
    if(recursive?.isSignerRecursion == true && recursive?.signerParams?.hasOwnProperty('signature_position') && recursive?.signerParams?.hasOwnProperty('trigger_esign_request')){
      saveRecursiveData['signature_position'] = recursive?.signerParams['signature_position'];
      saveRecursiveData['trigger_esign_request'] = IndirectEval(recursive?.signerParams['trigger_esign_request']);
    }
    if(recursive?.isSignerRecursion == true){
      saveRecursiveData['co_signer'] = true
    }
    if(deleteRecursiveDocument){
      deleteRecursiveDocument?.map((ele)=>{
        dispatch(setdeleteDocument({key:'',value:ele}))
      })
      dispatch(cleardeleteRecursiveDocument())
    }
    let recursiveNameFields = [];
    fields?.filter((data) => data?.type !== "subheader")?.input_fields?.map((item) => {
      if (item.type == "toggle") return;
      return recursiveNameFields.push({ name: item.name, label: item.label });
    });

    recursiveNameFields.map((item) => {
      dispatch(clearRecursiveFormDataKey({ key: item.name }));
    });

    dispatch(setShowData(setShowRecursiveData));
    dispatch(setAddSaveData(saveRecursiveData));
    dispatch(setShowRecursiveForm(false));
    dispatch(setShowAddMore(true));
    dispatch(setShowDataPreview(true));
    
  };
  const handleUpdateCustom = (params) =>{
    let data 
    if(IndirectEval(params?.auto_fill_trigger)){
       data = autoFillData(params?.autofill,selectedData)
    }
    handleUpdateRequestedChanges(data)
  }

  var validateAndSubmit = async(action,params) => {
    let validateFields = [];
    let fieldType = "";
    let fieldRequired = ';'
    fields?.map((item) => {
      if (
        item.type == "group" ||
        item.type == "eMandate" ||
        item.type == "recursive" ||
        item.type == "quizModule" ||
        item.type == "questionnaire" ||
        item.type == "verification_group" ||
        item.type == "eSign"
      ) { 
        fieldType = item.type;
        item.input_fields?.map((_item) => {
          if (
            !_item.hasOwnProperty("show") ||
            (_item.hasOwnProperty("show") &&
            IndirectEval(_item.show))
          ) {
            validateFields = [...validateFields, _item];
          }
        });
      }
      // else if (item.type == "fieldRecursive") {
      //   // console.log(item);
      //   validateFields = [...validateFields,item]
      // }
      else {
        let fieldVisiblity = false;
        if (item.hasOwnProperty("show"))
          fieldVisiblity = IndirectEval(item?.show);
        else fieldVisiblity = true;

        if (fieldVisiblity) {
          validateFields = [...validateFields, item];
        }
      }
    });

    let errors;
    if (params?.isRecursive) {
      errors = await  validate(validateFields, recursiveFormData, dispatch,staticData,null,recursive,selectedData);
    }else if(fieldType == "eSign") {
      errors =  await validateESign(fields, selectedData);
    } else if (fieldType === "quizModule" || fieldType === "questionnaire") {
      errors = await validate(validateFields, selectedQuestion, dispatch, workflowUser);
    } else {
      if (dataPreview && !showRecursiveForm) {
        errors = {};
      } else {
        errors = await validate(validateFields, selectedData, dispatch,staticData,workflowUser);
      }
    }
    // payload as in handleNExt
    let formattedData = { ...selectedData };

    let payload;
    if (saveData && saveData.length) {
      let recursiveData = {};
      let signer_data = []
      if(isSignerRecursion  && recursive?.signerParams?.signer_validation_name){
        // signer_data = getAllSignerId(config?.wf_journey[0]?.form_structure?.sections)
        signer_data = [...recursive?.signerParams?.signer_validation_name,arrayName]
      }
      let isRecursiveData = 'true';
      recursiveData[arrayName] = saveData;
      // dispatch(clearSaveData());
      // dispatch(clearShowData());
      payload = createUserWorkflowPayload(
        formattedData,
        recursiveData,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        isSignerRecursion,
        signer_data,
        documents,
        deleteDocument,
        null,
        isRecursiveData
      );
    } else {
      payload = createUserWorkflowPayload(
        formattedData,
        null,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        null,
        null,
        documents,
        deleteDocument,
        evaluationRule
      );
    }
    let formattedpayload 
    if (payload) {
      formattedpayload = {
        ...payload,
        userId: decryptedId.subWfId,
        user_initiated_flow: true,     //Changed Key isRMFlow to user_initiated_flow
        requestedId: requestedId,
      };    
    }

    let errKeys = Object.keys(errors);
    if (errKeys?.length === 0) {
      // eslint-disable-next-line default-case
      switch (action) {
        case "add":
          handleAdd();
          break;
          case "next":
          handleNext(params);
          break;
        case "update":
          handleSubmit();
          break;
          case "updateSection":
            handleSubmit();
            break;
        case "handleSubmitApplication":
          submitApplication(params);
          break;
        case "submit":
          handleSubmission(params);
          break;
        case "updateRequestedChanges":
          handleUpdateRequestedChanges();
          break;
        case "updateCustom":
          handleUpdateCustom(params);
          break;
        case "physicalFormSubmission":
          finalSubmission(formattedpayload,"/update-successful?physical_form=true",params);
          break;
          case "paymentSubmit":
            handlePaymentInitiation(params);
            break;
      }
      return;
    } else {
      setFormErr(errors);
      const container = document.getElementById("dynamic_form_container");
      if(errors){
        container.scrollTo({top:0, behavior:'smooth'});
      }
      params?.isRecursive ? dynamicFormScrollBottom() : dynamicFormScroll();
    }
    return errors
  };

  const handleSubmission = async (params) => {
    let formattedData = { ...selectedData };
    let payload;
    if (saveData && saveData.length) {
      let signer_data = []
      if(isSignerRecursion  && recursive?.signerParams?.signer_validation_name){
        // signer_data = getAllSignerId(config?.wf_journey[0]?.form_structure?.sections)
        signer_data = [...recursive?.signerParams?.signer_validation_name,arrayName]
      }
      let isRecursiveData = 'true';
      let recursiveData = {};
      recursiveData[arrayName] = saveData;
      dispatch(clearSaveData());
      dispatch(clearShowData());
      payload = createUserWorkflowPayload(
        formattedData,
        recursiveData,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        isSignerRecursion,
        signer_data,
        documents,
        null,
        isRecursiveData
      );
    } else if (savedFormData) {
      let recursiveData = {};
      recursiveData[fieldRecursiveName] = savedFormData;
      payload = createUserWorkflowPayload(
        formattedData,
        recursiveData,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        isSignerRecursion,
        saveData,
        documents
      );
    } else {
      payload = createUserWorkflowPayload(
        formattedData,
        null,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        null,
        null,
        documents
      );
    }

    if (payload) {
      let formattedpayload = {
        ...payload,
        userId: decryptedId.subWfId,
      };
      let statusUpadte = {
        status: params?.status_to_update,
        applicant_id:decryptedId.subWfId
      };
      await dispatch(updateApplicantStatusAndSubWorkflowStatus(statusUpadte))

      await dispatch(updateWorkflowInfo(formattedpayload));
      navigate("/update-successful");
      //* Reseting Recursive states to default
      dispatch(setIsSignerRecursion(false));
      dispatch(setIsToggled(false));
      dispatch(setShowDataPreview(false));
      dispatch(clearSaveData());
      dispatch(clearShowData());
      dispatch(clearFieldRecursionData());
      dispatch(clearSignerParams())
    }
    // navigate('/update-successful')
  };

  const handleGenerateForm = () => {};

  const clearFieldError = (fields, isList) => {
    fields = isList ? fields : [fields];
    let err = { ...stateErrRef?.current };

    for (let key in fields) {
      const _field = fields[key];
      if (err[_field] !== undefined) {
        delete err[_field];
      }
    }
    setFormErr(err);
  };
  
  const finalSubmission = async (dataToUpdateWorkflow, navigationLink,params) => {
    const dynamicFormConfig = wfJourney.find((item,index) => {
      if (item?.module_name === 'Dynamic Forms' && item?.type != "default" &&  item?.step === activeStepOfUser)
      // if (item?.module_name === 'Dynamic Forms')
        return item
    })

    if (primaryUser && primaryUser?.source_data && primaryUser?.source_data?.subworkflows) {
      let data={
        status : dynamicFormConfig?.is_conditional ? eval(dynamicFormConfig?.next_activity) : dynamicFormConfig?.next_activity,
        active_step : dynamicFormConfig?.is_conditional ? eval(dynamicFormConfig?.next_step) : dynamicFormConfig?.next_step
      }
      await dispatch(
        updateWorkflowInfo({
          userId: decryptedId?.subWfId,
          status: data?.status,
          module_name: dynamicFormConfig?.module_name,
          active_step: parseInt(data?.active_step),
          ...dataToUpdateWorkflow,
          stage : stage
        })
      ).unwrap();
    }

    dispatch(cleardeleteDocument())
    if (params?.callbacks_triggers){
      params?.callbacks_triggers.forEach((callback) => {
        if (!IndirectEval(callback.required)) return;
        callback = IndirectEval(callback);
        let evaluatedCallbackParams = {};
        Object.entries(callback.params).map((item) => {
          let key = item[0];
          let val = item[1];
          evaluatedCallbackParams[key] = IndirectEval(val);
        });
        let evaluatedCallback = {
          ...evaluatedCallbackParams,
          subWfID : workflowUser.subworkflows?._id
        };
        triggerButtonCallback(evaluatedCallback,dispatch);
      });
    } 
     // This code handles the logout process for UAE Pass after submitting an application. 
  // It clears the UAE Pass session and redirects the user to the appropriate page.
  if (dataToUpdateWorkflow?.source_data?.uae_pass_linking_type) {
    const fullURL = window.location.href;
    // Creating a URL object
    const url = new URL(fullURL);
    // Geting the base URL up to '/unified'
    const segments = url.pathname.split("/");
    // Checking if the second segment is 'unified'
    const baseURL = `${url.protocol}//${url.host}/${segments[1]}`;
    let navUrl = `${baseURL}${navigationLink}`;
    window.location.href = `${UAE_PASS_ROUTE}/logout?redirect_url=${navUrl}`;
  } 
    let stateData ={
      content_trigger:params?.content_trigger,
      organisation_id:organisation_id
        }
        let encryptedData = await encrypt(stateData)
          sessionStorage.setItem("stateData", JSON.stringify(encryptedData));
          if (navigationLink) navigate(navigationLink);
  };

  const submitApplication = async (params) => {
    if (params?.callbacks_triggers) {
      params?.callbacks_triggers.forEach((callback) => {
        if (!IndirectEval(callback.required)) return;
        callback = IndirectEval(callback);
        let evaluatedCallbackParams = {};
        Object.entries(callback.params).map((item) => {
          let key = item[0];
          let val = item[1];
          evaluatedCallbackParams[key] = IndirectEval(val);
        });
        let evaluatedCallback = {
          ...evaluatedCallbackParams,
          has_link_expiry: true, // when a email is been sent for declarations or risk profiling it will have expiry time and it depends only if that organisation is configured to have expiry
          subWfID : workflowUser.subworkflows._id
        };
        triggerButtonCallback(evaluatedCallback, dispatch);
      });
    }
    if(params?.status_to_update && !loggedUserId ){
      await dispatch(
        updateApplicantStatusAndSubWorkflowStatus({
          applicant_id: decryptedId?.subWfId,
          status: params?.status_to_update,
        })
      ).unwrap();
      }
    await handleNext(params?.status_to_update);
    if(isUserInitiated){
      const stateData = {
         content_trigger :params?.content_trigger,
        organisation_id:organisation_id
      };
      let encryptedData = await encrypt(stateData)
        sessionStorage.setItem("stateData", JSON.stringify(encryptedData));
        navigate("/update-successful");
    }
  };

  const skipApplication = async (status_to_update,callbacks_triggers,content_trigger) => {
    if (callbacks_triggers){
      callbacks_triggers.forEach((callback) => {
        if (!IndirectEval(callback.required)) return;
        callback = IndirectEval(callback);
        let evaluatedCallbackParams = {};
        Object.entries(callback.params).map((item) => {
          let key = item[0];
          let val = item[1];
          evaluatedCallbackParams[key] = IndirectEval(val);
        });
        let evaluatedCallback = {
          ...evaluatedCallbackParams,
        };
        triggerButtonCallback(evaluatedCallback,dispatch);
      });
    }
    if(status_to_update && !loggedUserId){
    await dispatch(
      updateApplicantStatusAndSubWorkflowStatus({
        applicant_id: decryptedId?.subWfId,
        status: status_to_update,
      })
    ).unwrap();
    }
    handleSkip(status_to_update);
    if(isUserInitiated){
      const stateData = {
        content_trigger:content_trigger,
        organisation_id:organisation_id
      };
      let encryptedData = await  encrypt(stateData)
        sessionStorage.setItem("stateData", JSON.stringify(encryptedData));
        navigate("/update-successful");
    }
  };
  const handleConsentUpdate = async (params,content_trigger, callbacks_triggers) => {
    if (callbacks_triggers) {
      console.log()
      callbacks_triggers.forEach((callback) => {
        if (!IndirectEval(callback.required)) return;
        callback = IndirectEval(callback);
        let evaluatedCallbackParams = {};
        Object.entries(callback.params).map((item) => {
          let key = item[0];
          let val = item[1];
          evaluatedCallbackParams[key] = IndirectEval(val);
        });
        let evaluatedCallback = {
          ...evaluatedCallbackParams,
          has_link_expiry: true, // when a email is been sent for declarations or risk profiling it will have expiry time and it depends only if that organisation is configured to have expiry
          subWfID : workflowUser.subworkflows._id
        };
        triggerButtonCallback(evaluatedCallback, dispatch);
      });
    }
    finalSubmission(params, "/update-successful",content_trigger);
  };

  const handleFormCompleted = async () => {
    let declarationobjects;
      if(consentType && consentId && consentText) {
        declarationobjects = {
          consent_type: consentType,
          consent_id: consentId,
          consent_text: consentText,
          approved_at: moment(new Date()),
        }
      } else declarationobjects = null;
    await finalSubmission(declarationobjects, "/update-successful");
    dispatch(setConsentConfig());
  }
  
  const handleDeclarationAcceptance = (content_trigger, callbacks_triggers) => {
   let declarationarray = [...declarationConsent];
    if (!declarationarray.find((item) => item.consent_id === consentId)) {
      let declarationobjects = {
        consent_type: consentType,
        consent_id: consentId,
        consent_text: consentText,
        approved_at: moment(new Date()),
      };
      declarationarray.push(declarationobjects);
      dispatch(setdeclarationConsent(declarationarray));
    }
     
    let nextSection = stepperSections[activeSection]?.section_order + 1;
    let maxStepperSectionIndex =
      Object.keys(stepperSections).filter((key) => {
        const eachSection = stepperSections[key];
        return IndirectEval(eachSection?.display_section);
      }).length - 1;
    // console.log(parseInt(Object.keys(stepperSections)[0]));
    maxStepperSectionIndex += parseInt(Object.keys(stepperSections)[0]);
    if (!decryptedId?.subWfId) {
      dispatch(dispatch(incrementActiveStepOrder()));
    } else if (nextSection === maxStepperSectionIndex) {
      dispatch(changeActiveSection(nextSection));
      dispatch(changeMaxActiveSection(nextSection));
    } else if (nextSection > maxStepperSectionIndex) {
      handleConsentUpdate({consents_approved:declarationarray} ,{content_trigger:content_trigger}, callbacks_triggers); //active_step change to dynamic
    } else {
      dispatch(changeActiveSection(nextSection));
      dispatch(changeMaxActiveSection(nextSection));
    }
  }

  const populateStepperWithConsent = (_item,form_group) => {
    let updatedSections = {};
    let count = activeSection
    _item.consents.map((item, index) => {
      let concentValidate = IndirectEval(item.show)
      return (concentValidate ? (updatedSections[count] = {
        title: item?.label,
        name: item?.label,
        form_groups: [
          {
            display_group: true,
            show: true,
            group_order: 1,
            group_length:1,
            form_elements: [
              {
                name: item?.label,
                layout: item?.layout,
                show: true,
                consent_id: item.consent_id,
                title: item.title,
                type: "singleConsent",
              },
            ],
            form_buttons: [...form_group?.form_buttons]
          },
        ],
        section_order: count,
        section_status:item?.status,
        display_section: item.show,
        element_number: count++,
        show: item?.show,
        content: item?.content,
        is_checked: item?.is_checked,
        heading: item?.heading,
      }):'');
    });
    dispatch(setConsentSections(updatedSections));
    dispatch(setSections(updatedSections));
    if (_item.layout === "wizard") dispatch(setStepperDisplay(true));
  };

  /**
   ** This function initiates the Authentication process with UAE Pass
   ** To use this function use the button action as {uae_pass_auth} in the config
   */
   const handleUaePassAuth = async (fieldName, trigger) => {
    try {
      /**
       ** First calling the handleNext() function to save the entered details and
       ** then will initiate the UAE Pass auth process.
       */
      // const applicantData = await handleNext(fieldName, trigger, true);

      const origin = window.location.origin;
      // const redirectionUrl = `${origin}/unified${applicantData.link}`

      const response = await initiateUaePassAuth({
        reference_id   : "xxxx",
        callback_url : "https://in-unified.qa-signdesk.com/api/uae-pass/authCallback",
        //* Once the UAE Pass auth is successful then the user will be redirected to this url
        redirection_url: window.location.href 
      });

      // * If we the UAE pass auth is successfully initiated
      if(response?.status.toLowerCase() === "success") {
        const authenticationUrl = response.data?.authentication_url;
        if(!authenticationUrl) throw new Error("Authentication URL is not found!");

        // * Navigating the user to the UAE Pass authentication URL
        window.location.replace(authenticationUrl);
      }

    } catch (err) {
      console.log(err);
    }
  }


  // if (!Object.keys(primaryUser).length) return <LoadingSpinner/>;
  // if (workflowLoader) return <LoadingSpinner/>;
  // if (configLoader) return <LoadingSpinner/>;
  if (
    (!dynamic_wf &&
      (!Object.keys(primaryUser).length ||
        isRoutingToPaymentObject?.isRoutingToPayment ||
        isPAymentIDCreationInProgress?.current ||
        isRoutingToPaymentObject?.isRoutingInternalUserAsHeCannotPay)) ||
    workflowLoader ||
    configLoader ||
    isRoutingToPaymentObject?.isRoutingToPayment ||
    isPAymentIDCreationInProgress?.current ||
    isRoutingToPaymentObject?.isRoutingInternalUserAsHeCannotPay
  )
    return <LoadingSpinner />;
  let subWorkflow = primaryUser?.source_data?.subworkflows;
  return (
    <Layout
      nav_orientation={formStructure?.nav_orientation}
      allignment_position={formStructure?.allignment_position}
      selectedData={selectedData}
      formErr={formErr}
      setFormErr={setFormErr}
      config={config}
      validateAndSubmit={validateAndSubmit}
    >
      {Object.entries(stepperSections)?.map((item, index) => {
        index = parseInt(item[0]);
        item = item[1];
        const { section_order, is_last_section, redirect_url,display_section,restricted_view } = item;
        if (section_order === activeSection) {
          if (IndirectEval(display_section)){
            if (restricted_view) {
              subWorkflow?.map((_item) => {
                if (decryptedId.subWfId == _item?._id) {
                  if (decryptedId.userId != _item?.user_id) {
                    dispatch(setRestrictedView(true));
                  } else dispatch(setRestrictedView(false));
                  }
                }
              );
            }
              
          if (is_last_section) {
            primaryUser?.source_data?.subworkflows.map((_item) => {
              if (decryptedId.subWfId == _item?._id) {
                if (decryptedId.userId == _item?.user_id) {
                  dispatch(setConsentId(item.consent_id));
                  return navigate(
                    `/consents/${decryptedId.primaryWorkflowId}/${decryptedId.userId}/${decryptedId.subWfId}`
                  );
                } else alert("Consent should be made by co-applicant");
              }
            });
          } else {
            let activeElement = stepperSections?.[
              activeSection
            ]?.form_groups?.findIndex((item) => item.group_order == activeGroup);
            // if (item?.form_groups?.[activeElement]?.show) {
              if (IndirectEval(item.form_groups[activeElement]?.show)) {
                fields = item.form_groups[activeElement].form_elements;
                return (
                  <>
                    {item.form_groups[activeElement].form_elements?.map(
                      (element, index) => {
                        if (element.type === "recursive") {
                          if(element.signer_recursion){
                            dispatch(setIsSignerRecursion(element.signer_recursion))
                          }
                          return (
                            <Fragment key={index}>
                              <Recursive
                                recursiveTrigger={element.recursive_trigger}
                                customStyle={element.custom_styles}
                                recursiveName={element.name}
                                inputFields={element.input_fields}
                                handleNext={validateAndSubmit}
                                handleAdd={handleAdd}
                                handleSkip={handleSkip}
                                handleCancel={handleCancel}
                                selectedData={recursiveFormData}
                                setSelectedData={setRecursiveFormData}
                                recursiveActions={element.recursive_actions}
                                dataPreview={dataPreview}
                                clearFieldError={clearFieldError}
                                formErr={formErr}
                                recursiveRead = {element.read}
                                setFormErr={setFormErr}
                                recursiveTitle={element.title}
                                minLength={element.min_length}
                                maxLength={element.max_length}
                                SignerRecursion = {element.signer_recursion}
                                triggerEsignRequest = {element.trigger_esign_request}
                                signaturePosition = {element.signature_position}
                                signer_validation_name = {element.signer_validation_name}
                              />
                            </Fragment>
                          );
                        }
                        if (element.type === "questionnaire") {
                          return (
                            <Fragment key={index}>
                              <Question
                                isUserInitiated={!loggedUserId}
                                inputFields={element.input_fields}
                                handleNext={handleNext}
                                handleAdd={handleAdd}
                                handleSkip={handleSkip}
                                handleCancel={handleCancel}
                                clearFieldError={clearFieldError}
                                formErr={formErr}
                                selectedData={selectedQuestion}
                                setSelectedData={setSelectedData}
                                questionnaireId={element.id}
                                evaluationRules={element.rules}
                              />
                            </Fragment>
                          );
                        }
                        if (element.type === "quizModule") {
                          return (
                            <Fragment key={index}>
                              <QuizModule 
                                   isUserInitiated={!loggedUserId}
                                   inputFields={element.input_fields}
                                   handleNext={handleNext}
                                   handleAdd={handleAdd}
                                   handleSkip={handleSkip}
                                   handleCancel={handleCancel}
                                   clearFieldError={clearFieldError}
                                   formErr={formErr}
                                   selectedData={selectedQuestion}
                                   setSelectedData={setSelectedData}
                                   questionnaireId={element.id}
                                   evaluationRules={element.rules}
                              />
                            </Fragment>
                          );
                        }
                        if (element.type === "consent") {
                          populateStepperWithConsent(element,item.form_groups[activeElement]);
                          return;
                        }
                        if (element.type === "singleConsent" || element.type === "declarationConsent") {
                          return (
                            <Fragment key={index}>
                              <Consent
                                finalSubmission={finalSubmission}
                                consentName={element.name}
                                layout={element.layout}
                                consent={element}
                                setSelectedData={setSelectedData}
                              />
                            </Fragment>
                          );
                        }
                        if (element.type === "group") {
                          if (eval(element.show)) {
                          return (
                            <Fragment key={index}>
                              <Group
                                formErr={formErr}
                                clearFieldError={clearFieldError}
                                formFields={element?.input_fields}
                                handleNext={handleNext}
                                handleCancel={handleCancel}
                                handleAdd={handleAdd}
                                handleSkip={handleSkip}
                                handleBack={handleBack}
                                setFormErr={setFormErr}
                                selectedData={selectedData}
                                setSelectedData={setSelectedData}
                                digilocker = {element?.digilocker}
                                name = {element?.name}
                               
                              />
                            </Fragment>
                          );
                        }
                        }
                        if (element.type === "eMandate") {
                          return (
                            <Fragment key={index}>
                              <Emandate
                                formErr={formErr}
                                formFields={element?.input_fields}
                                clearFieldError={clearFieldError}
                                setFormErr={setFormErr}
                                selectedData={selectedData}
                                setSelectedData={setSelectedData}
                              />
                            </Fragment>
                          )
                        }
                        if (element.type === "verification_group") {   
                          return (
                            <Fragment key={index}>
                              <VerificationGroup
                                formErr={formErr}
                                clearFieldError={clearFieldError}
                                setFormErr={setFormErr}
                                formFields={element?.input_fields}
                                handleNext={handleNext}
                                selectedData={selectedData}
                                setSelectedData={setSelectedData}
                                name = {element?.name}
                                className={element?.custom_styles}
                                verificationFields = {element?.verification_button}
                                verifiedText = {element?.verified_text}
                              />
                            </Fragment>
                          );
                        }
                        if (element.type === 'eSign') {
                          return (
                            <Fragment key={index}>
                              <Esign
                                clearFieldError={clearFieldError}
                                formFields={element}
                                selectedData={selectedData}
                                setSelectedData={setSelectedData}
                                handleNext={validateAndSubmit}
                                formErr={formErr}
                              />
                            </Fragment>
                          )
                        }
                        if (element.type === "fieldRecursive") {
                          return (
                            <Fragment key={index}>
                              <FieldRecursive
                                inputFields={element.input_fields}
                                handleNext={validateAndSubmit}
                                handleAdd={handleAdd}
                                handleSkip={handleSkip}
                                handleCancel={handleCancel}
                                selectedData={recursiveFormData}
                                setSelectedData={setRecursiveFormData}
                                recursiveActions={element.recursive_actions}
                                dataPreview={dataPreview}
                                clearFieldError={clearFieldError}
                                formErr={formErr}
                                recursiveTitle={element.title}
                                minLength={element.min_length}
                                maxLength={element.max_length}
                               
                              />
                            </Fragment>
                          );
                        }
                        if (element.type === "payment_transactions") {
                          return (
                            <Fragment key={`${element.name}_${index+1}`}>
                              <PaymentTransactionPreview
                                recursiveName={element.name}
                                inputFields={element.input_fields}
                                handleNext={validateAndSubmit}                  
                                handleCancel={handleCancel}
                                selectedData={recursiveFormData}
                                recursiveTitle={element.title}
                                minLength={element.min_length}
                                maxLength={element.max_length}
                                paymentModuleID={element.name}
                                fields_to_be_date_formatted={element.fields_to_be_date_formatted}
                              />
                            </Fragment>
                          );
                        }
                         else {
                          // dispatch(setShowDataPreview(false));
                          return (
                            <Fragment key={index}>
                              <DynamicForm
                                formErr={formErr}
                                clearFieldError={clearFieldError}
                                formFields={element}
                                selectedData={selectedData}
                                setFormErr={setFormErr}
                                setSelectedData={setSelectedData}
                                reqDocsObject={reqDocsObject}
                                read_mode={read_mode}
                              />
                            </Fragment>
                          );
                        }
                      }
                    )}
                    { read_mode !== true && ( // if read mode is true then don't show buttons
                      <FormButton
                        formButtons={
                          // if requestedId is present and requestedDocs is present in redux then show update buttons
                          requestedId && requestedDocs
                            ? read_mode ? "": updateCustomBtn == 'true' ? item.form_groups[activeElement]?.form_buttons :handleUpdateButtons
                            : item.form_groups[activeElement]?.form_buttons
                        }
                        handleDeclarationAcceptance={handleDeclarationAcceptance}
                        handleGenerateForm={handleGenerateForm}
                        handleNext={validateAndSubmit}
                        handleSubmission={handleSubmission}
                        handleFinalSubmisssion={finalSubmission}
                        handleSubmitApplication={validateAndSubmit}
                        handleSkipApplication={skipApplication}
                        handleCancel={handleCancel}
                        // selectWorkflow={selectWorkflow}
                        handleBack={handleBack}
                        handleSkip={handleSkip}
                        selectedData={selectedData}
                        isMobile={isMobile}
                        handleSubmitRequestedChanges={validateAndSubmit}
                        handleUpdateCustom = {validateAndSubmit}
                        handleUaePassAuth={handleUaePassAuth}
                        handlePaymentInitiation={validateAndSubmit}
                        handleFormCompleted={handleFormCompleted}
                      />
                   )} 
                  </>
                );
              } else {
                handleNext();
              }
            // }
          }
          }
          else {
            handleNext();
          }
        }
      })}
    </Layout>
  );
};

export default FormDisplay;